import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Homepage from './pages/Homepage';
import Profile from './pages/Profile';
import Help from './pages/Help';
import About from './pages/About';
import ContactUs from './pages/ContactUs';
import NewsEvents from './pages/NewsEvents';
import EventPage from './pages/EventPage';
import NewsPage from "./pages/NewsPage";
import AllNewsPage from './pages/AllNewsPage';
import AllEventsPage from './pages/AllEventsPage';
import AllVidTutPage from './pages/AllVidTutPage';
import AllReferencesPage from './pages/AllReferencesPage';
import AllModelsPage from './pages/AllModelsPage';
import Resources from './pages/Resources';
import TutorialPage from './pages/TutorialPage';
import ReferencesPage from './pages/ReferencesPage';
import ModelPage from './pages/ModelPage';
import SimulationPage from './pages/SimulationPage';
import SearchResults from './pages/SearchResults';
import ResponsiveAlert from './components/ResponsiveAlert';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';


import Test from './pages/Test';

function App() {
  return (
    <>
      {/* Alert visible on all pages */}
      <ResponsiveAlert />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/help" element={<Help />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/news-events" element={<NewsEvents />} />
        <Route path="/news-events/events/:eventId" element={<EventPage />} />
        <Route path="/news-events/news/:newsId" element={<NewsPage />} />
        <Route path="/news-events/news" element={<AllNewsPage />} />
        <Route path="/news-events/events" element={<AllEventsPage />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/resources/videos-tutorials/:tutId" element={<TutorialPage />} />
        <Route path="/resources/videos-tutorials" element={<AllVidTutPage />} />
        <Route path="/resources/references/:refId" element={<ReferencesPage />} />
        <Route path="/resources/references/" element={<AllReferencesPage />} />
        <Route path="/models" element={<AllModelsPage />} />
        <Route path="/models/:modelId" element={<ModelPage />} />
        <Route path="/models/sim/:modelId" element={<SimulationPage />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/test" element={<Test />} />
        {/* Account main page */}
        <Route 
          path="/account" 
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          } 
        />

        {/* Account page with optional info message */}
        <Route 
          path="/account/:id" 
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </>
  );
}

export default App;
